import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Canal para abrir el diálogo global de reporte desde fuera del FAB/atajo
 * (p. ej. el acceso rápido "Reportar issue" del centro de pruebas).
 * `IssueReporterComponent` vive en AppLayout, así que no es alcanzable por
 * referencia directa desde las rutas hijas.
 */
@Injectable({ providedIn: 'root' })
export class IssueReporterService {
  private readonly openSubject = new Subject<void>();
  readonly openRequests$ = this.openSubject.asObservable();

  open() { this.openSubject.next(); }
}
